// JavaScript Document

// eslint-disable-next-line no-unused-vars
export default class FetchBuilder {
  method = null;
  path = null;
  parameters = [];
  url = null;
  cache = 'no-cache';
  redirect = 'follow';
  signal = null;
  body = null;

  constructor(method, path, parameters) {
    this.method = method;
    this.path = path;
    this.parameters = parameters;

    this.url = null;
    this.cache = 'no-cache';
    this.redirect = 'follow';
    this.signal = null;
    this.body = null;

    this.build();
  }

  build() {
    this.url = this.path;
    if (this.method == 'GET') {
      for (let i = 0; i < this.parameters.length; i++) {
        this.url += `${(i == 0 ? '?' : '&') + this.parameters[i].name}=${
          this.parameters[i].value
        }`;
      }
    } else if (this.method == 'POST') {
      const formdata = new FormData();
      for (let i = 0; i < this.parameters.length; i++) {
        formdata.append(this.parameters[i].name, this.parameters[i].value);
      }
      this.body = formdata;
    }

    // add new controller to the map for this fetch
    const controller = new AbortController();
    this.signal = controller.signal;
  }

  toFetchOptions() {
    const fetchOptions = new Object();
    if (this.method != null) fetchOptions.method = this.method;
    if (this.cache != null) fetchOptions.cache = this.cache;
    if (this.redirect != null) fetchOptions.redirect = this.redirect;
    if (this.signal != null) fetchOptions.signal = this.signal;
    if (this.body != null) fetchOptions.body = this.body;
    return fetchOptions;
  }
}

export { FetchBuilder };
